function querystring(): any {
  return window.location.search
    .slice(1)
    .split('&')
    .reduce((acc, part) => {
      const [key, value] = part.split('=')
      return {
        ...acc,
        [key]: value
      }
    }, {})
}

export default querystring
